import { ConfigProvider } from '@e-kyc/configuration';
import { Routes } from '@generouted/react-router';
import * as Sentry from '@sentry/react';
import { ApolloProvider, createApolloClient } from '@shared/apollo';
import { getExternalForceLogout } from '@shared/auth';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';

import { configuration } from './configuration';
import '@e-kyc/translations';
import './styles/global.css';
import { tokenManager } from './providers/e-kyc/utils/token-manager';
import { NetworkProvider } from './providers/network/NetworkProvider';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const { graphql } = configuration;
const defaultFetchPolicy = 'network-only';
const token = tokenManager.getToken();

const client = createApolloClient(
  graphql.apiUrl,
  {
    query: { fetchPolicy: defaultFetchPolicy },
    watchQuery: { fetchPolicy: defaultFetchPolicy },
  },
  {
    token,
    onUnauthorized: () => getExternalForceLogout()?.(),
  },
);

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn && !import.meta.env.DEV) {
  Sentry.init({
    dsn,
    sendDefaultPii: true,
    environment: import.meta.env.MODE,
  });
}

root.render(
  <StrictMode>
    <NetworkProvider>
      <ConfigProvider config={configuration}>
        <ApolloProvider client={client}>
          <Routes />
        </ApolloProvider>
      </ConfigProvider>
    </NetworkProvider>
  </StrictMode>,
);
